module.exports = __webpack_public_path__ + "static/media/dimensions.5a0b9938.svg";